import { IEndpoint } from 'interfaces/IEndPoint';
import AuthProtect from 'common/enums/AuthProtect';
import { IRequestDetails } from 'interfaces/ResourceRequests';
import { ICreateResponse } from 'interfaces/response.interface';
import { IIncident } from 'interfaces/incident.interface';

export interface ApiRequestsFilters {
  limit?: number;
  offset?: number;
  archived?: number;
}

export interface ApiIncidentsFilters {
  limit?: number;
  offset?: number;
  archived?: number;
}

function setRequestsParams(filters: ApiRequestsFilters): ApiRequestsFilters {
  const params: ApiRequestsFilters = {};
  if (filters.offset || filters.offset === 0) {
    params.offset = filters.offset;
  }

  if (filters.limit) {
    params.limit = filters.limit;
  }

  if (filters.archived) {
    params.archived = filters.archived;
  }

  return params;
}

export const addRequest = (data: IRequestDetails): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'POST',
    url: 'request',
    data,
  };
};

export const updateRequest = (data: IRequestDetails): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'PUT',
    url: 'request',
    data,
  };
};

// Fetch APIs
export const getRequests = (filters: ApiRequestsFilters): IEndpoint => {
  const params = setRequestsParams(filters);
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url: 'request',
    params: params,
  };
};

export const getRequestMagic = (accessToken: string): IEndpoint => {
  const params = { access_token: accessToken }; // eslint-disable-line
  return {
    authorization: AuthProtect.NOT_REQUIRED,
    method: 'GET',
    url: 'response/magiclink',
    params,
  };
};

export const addResponse: (
  payload: ICreateResponse,
  params: Partial<{ authorize: boolean; accessToken: string }>,
) => IEndpoint = (payload, params) => {
  return {
    authorization: params?.authorize ? AuthProtect.REQUIRED : AuthProtect.NOT_REQUIRED,
    url: params?.authorize ? 'response' : `response?access_token=${params?.accessToken}`,
    method: 'POST',
    data: payload,
  };
};

export const changeResponse: (
  payload: ICreateResponse,
  params: Partial<{ authorize: boolean; accessToken: string }>,
) => IEndpoint = (payload, params) => {
  return {
    authorization: params?.authorize ? AuthProtect.REQUIRED : AuthProtect.NOT_REQUIRED,
    url: params?.authorize ? 'response' : `response?access_token=${params?.accessToken}`,
    method: 'PUT',
    data: payload,
  };
};

export const archiveRequest = (data: { id: string }): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'POST',
    url: 'request/archive',
    data,
  };
};

export const getMaxRequestNumber = (): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    url: 'request/requestNumber',
    method: 'GET',
  };
};

export const getOpenResponses = (): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    url: 'responses',
    method: 'GET',
  };
};

export const getRequestById = (id: string): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    url: `request/${id}`,
    method: 'GET',
  };
};

export const getResponseByRequest = (id: string): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    url: 'responses/request',
    method: 'GET',
    params: { requestId: id },
  };
};

export const addIncident = (data: IIncident): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'POST',
    url: 'incident',
    data,
  };
};

export const updateIncident = (data: IIncident): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'PUT',
    url: 'incident',
    data,
  };
};

export const getIncidents = (filters: ApiIncidentsFilters): IEndpoint => {
  const params = setRequestsParams(filters);
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url: 'incident',
    params: params,
  };
};

export const getIncidentById = (id: string): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    url: `incident/${id}`,
    method: 'GET',
  };
};

export const archiveIncident = (data: { id: string }): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'POST',
    url: 'incident/archive',
    data,
  };
};
